import { Component, Input, OnInit, Sanitizer } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Navigation } from '@angular/router';
import { Locale } from 'src/app/model/locale';
import { NavigationService } from 'src/app/services/navigation/navigation.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
})
export class FooterComponent implements OnInit {

  @Input() locale: Locale;

  constructor(
    private sanitizer: DomSanitizer,
    private navigationService: NavigationService,
  ) { }

  ngOnInit() { }

  get whatsappurl() {
    return this.sanitizer.bypassSecurityTrustUrl(`whatsapp://send?abid=${this.locale?.phone}`);
  }

  get mapsurl() {
    return this.sanitizer
      .bypassSecurityTrustUrl(
        `https://www.google.com/maps/place/Naki+Beach/@44.9171467,9.0302811,15z/data=!4m5!3m4!1s0x0:0x95cf8d8e986c62e0!8m2!3d44.9171831!4d9.0302389`
      );
  }

  openTermsConditions() {
    this.navigationService.goToTermsConditions();
  }
}
